import { useCallback, useRef, useState } from 'react';

import { toast } from '../../Toasts';
import api from '../api';

function useMarketData({ onSuccess }) {
  const memoOnSuccess = useRef(onSuccess);
  const dataByMarket = useRef({});

  const [loading, setLoading] = useState(false);

  memoOnSuccess.current = onSuccess;

  const fetchMarketData = useCallback((marketId) => {
    if (dataByMarket.current[marketId]) {
      memoOnSuccess.current(dataByMarket.current[marketId]);
    } else {
      setLoading(true);
      api
        .fetchMarketData(marketId)
        .then(({ data }) => {
          const decoratedData = data.map((entity) => ({ ...entity, value: entity.name }));
          memoOnSuccess.current(decoratedData);
          dataByMarket.current = {
            ...dataByMarket.current,
            [marketId]: decoratedData,
          };
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
          toast.error('Oops! Something went wrong. Please, try again later');
        });
    }
  }, []);

  return [
    {
      loading,
      memoDataByMarket: dataByMarket,
    },
    fetchMarketData,
  ];
}

export default useMarketData;
